// Author Liang Gangqiang
// Date 2021-03-18 16:13:23

import * as model from "@/model/sithMes/quality/SithMesQualityInspectTemplateModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityInspectTemplate(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
